import { isPlatformBrowser } from '@angular/common';
import {
  ElementRef,
  Inject,
  inject,
  Injectable,
  PLATFORM_ID
} from '@angular/core';
import { LoggingService } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class CommonServiceExtended {
  loggingService = inject(LoggingService);
  @Inject(PLATFORM_ID) platformId = Object;

  checkIEOrEdgeBrowser(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const isIEOrEdge = /msie\s|trident\/|edge\//i.test(
        window.navigator.userAgent
      );
      if (isIEOrEdge) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  rootDocList(nativeData: ElementRef) {
    let rootDocList;
    try {
      if (this.checkIEOrEdgeBrowser() === true) {
        rootDocList = document;
      } else {
        rootDocList = nativeData.nativeElement.ownerDocument;
      }
    } catch (e) {
      rootDocList = document.querySelector('body');
    }
    return rootDocList;
  }
}
